import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";

import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

function CriarAssistencia() {
  const MainContent = useDynamicComponent("AssistanceCreate");

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <PageTitle title={"Nova Assistência"} allowGoBack={true} />
        </div>

        <div className="pageBody">{MainContent}</div>
      </div>
    </Layout>
  );
}

export default CriarAssistencia;
